module.exports = __webpack_public_path__ + "img/Group 842.06a2ccce.svg";